import {Typography} from '@mui/material';
import {t} from 'i18next';
import styles from './styles.module.scss';
import {HTMLAttributes} from 'react';

type AurDataGridNoRowsOverlayProps = {
  message?: string;
  containerHeight?: number;
  containerClass?: string;
  indexDetails?:string;
} & HTMLAttributes<HTMLDivElement>;

const AurDataGridNoRowsOverlay: React.FC<AurDataGridNoRowsOverlayProps> = ({
  message = t('common.noResultFound'),
  containerHeight,
  containerClass,
}) => {
  let style = undefined;
  if (containerHeight) style = {height: `${containerHeight}px`};

  return (
    <div
      className={`${styles.aurContainer} ${containerClass}`}
      style={style}
      data-testid="empty-list-view"
    >
      <Typography className={styles.aurNotFoundTypography}>
        {message}
      </Typography>
    </div>
  );
};

export default AurDataGridNoRowsOverlay;
